import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ColorPicker from "../common/ColorPicker";
import downArrowIconWhite from '../../images/down_arrow_white.png';
import removeIcon from '../../images/clear-field-icon.png';

class ColorPickerInputBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorPickerFlag: false,
      textColor: this.getDefaultColor(this.props.modifiedPreferences),

    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    // const { modifiedPreferences } = this.props;
    if (!_.isEmpty(nextProps.modifiedPreferences)) {
      this.setState({
        textColor: this.getDefaultColor(nextProps.modifiedPreferences),
      });
    }
  }

  getDefaultColor = preferenceData => {
    if (!_.isEmpty(preferenceData)) {
      const colorKey = this.getdbKey(this.props.field.dbKey);
      const bgColor = preferenceData._sc !== 'undefined' ?
        preferenceData._sc[colorKey] : '';
      return bgColor;
    }
    return '';
  }

  getdbKey = colorKey => {
    const key = _.split(colorKey, '.');
    return key[1];
  }


  setDefaulatColorPickerInputBox = () => {
    this.setState({
      textColor: this.getDefaultColor(this.props.modifiedPreferences),
      colorPickerFlag: false,
    });
  }

  clickColorPickerInputBox = () => {
    this.setState((prevState) => ({
      colorPickerFlag: !prevState.colorPickerFlag,
    }));
  }

  handleTextColorChange = (color, button) => {
    if (button === 'textColor') {
      this.setState({ textColor: color.hex });
    } else {
      this.setState({ textColor: color.hex });
    }
    this.setState((prevState) => ({
      colorPickerFlag: !prevState.colorPickerFlag,
    }), () => {
      this.props.updatePreferences(this.props.field.dbKey, this.state.textColor);
    });
  };

  render() {
    return (
      <div>
        <div className="preference-custom-dropdown" style={{ width: '89%' }} 
            ref={node => {this.studySelElement = node;
            return this.studySelElement}}>
          <div className="custom-color-picker-dropdown-div">
            <button
              type = "button"
              style={{
                backgroundColor: this.state.textColor,
                color: this.state.textButtonColor,
              }}
              onClick={() => this.clickColorPickerInputBox(this.state.colorPickerFlag)}
              className="color-picker-dropdown"
            >
              <span className="perfrenceColorPickerLabel">
                {this.props.field.colorLabel ? this.props.field.colorLabel : 'Color'}
              </span>
              <span>
                <img
                  src={downArrowIconWhite}
                  className="color-pick-up-arrow-icon"
                  alt="up sort arrow"
                />
              </span>
            </button>
            <span onClick={this.setDefaulatColorPickerInputBox}>
              <img
                src={removeIcon}
                alt="clear-icon"
                onClick={this.setDefaulatColorPickerInputBox}
                className="clear-botton"
              />
            </span>
          </div>
        </div>
        <div />
        <div
          className="preferences-color-picker-position"
        >
          {this.state.colorPickerFlag === true &&
            <ColorPicker
              button="textColor"
              color={this.state.textColor}
              handleTextColorChange={this.handleTextColorChange}
            />
          }
        </div>
      </div>
    );
  }
}

ColorPickerInputBox.propTypes = {
  field: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string),
    defaultValue: PropTypes.number,
    dbKey: PropTypes.string,
    colorLabel: PropTypes.string,
  }),
  // label: PropTypes.string,
  updatePreferences: PropTypes.func,
  modifiedPreferences: PropTypes.shape({}),
};

export default ColorPickerInputBox;

